import { swal } from "@";

// Show confirmation dialog before resending messages
export const messageResendConfirmDialog = async () => {
  const { isConfirmed } = await swal(
    "تنبيه",
    "هل انت متاكد من اعادة الارسال",
    "نعم ارسل",
  );
  return isConfirmed;
};
